// Keep in sync with C:\work\Mojiscan\i18n.py APP_VERSION
export const MOJISCAN_VERSION = '2.1'
// Version code for download paths (dots removed), e.g. 1.1 -> 11
export const MOJISCAN_VERSION_CODE = MOJISCAN_VERSION.replace(/\./g, '')
export const MOJISCAN_ZIP_NAME = `MojiScan.${MOJISCAN_VERSION}.zip`
export const MOJISCAN_DOWNLOAD_BASE = 'https://www.searchplusplus.jp/download'
export const MOJISCAN_DOWNLOAD_URL = `${MOJISCAN_DOWNLOAD_BASE}/MojiScan/${MOJISCAN_VERSION_CODE}/${MOJISCAN_ZIP_NAME}`
export const MOJISCAN_PURCHASE_URL = 'https://buy.stripe.com/bJe5kE5ZA3Xnbva8Mv9bO00?locale=ja'
export const MOJISCAN_PROJECT_URL = 'https://startupaccelerator.dev/project/scan-pdf-tool'
// Startup Accelerator "featured" badge shown in the page header
export const MOJISCAN_BADGE_LINK = 'https://startupaccelerator.dev/project/scan-pdf-tool?ref=badge&p=34ARADJGEB'
export const MOJISCAN_BADGE_IMG_URL = 'https://startupaccelerator.dev/badge/128.svg'
export const MOJISCAN_TRIAL_DAYS = 30
export const MOJISCAN_TRIAL_PAGES_PER_DAY = 50

// Title graphic shown in the page header (same artwork as the app icon)
export const MOJISCAN_TITLE_URL = 'MojiScan_title.png'

// Screenshot (palette PNG, ~80 KB; original PNG kept at project root)
export const MOJISCAN_SCREENSHOT_URL = 'MojiScan_screenshot.png'

// User manual PDFs (hosted at site root, same convention as manual.pdf)
export const MOJISCAN_MANUAL_URL = 'MojiScan_User_Guide.pdf'
export const MOJISCAN_MANUAL_JA_URL = 'MojiScan_User_Guide_JA.pdf'
